import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import ReusableButton from '../../SharedComponents/Button/Button'
import ReusableTextBox from '../../SharedComponents/Textbox/Textbox'
import CoopDashboardLoginLogo from '../../Images/coopLogoDashboard.png'
import Loading from '../../Images/loading.gif'
import DashboardLogo from '../../SharedComponents/DashboardLogo/DashboardLogo'
import '../../CSS/global.css'
import './DashboardLogin.css'
import { Authentication } from '../../CleanersDashboardAPI/CleanersDashboardloginApi'
import {IoMdArrowBack } from 'react-icons/io'
import { GetVendors } from '../../CleanersDashboardAPI/CleanersDashboardGetAPI'
import { destroySession } from '../../Utility/Utility';
import * as DashboardLoginConstant from './DashboardLoginConstant'
import bcrypt from 'bcryptjs';
const $ = require('jquery')

// $.extend($.easing, window.easing);

class DashboardLogin extends Component {
    constructor(props) {
        super(props)
        this.state = {
            Username: '',
            Password: '',
            loading: false,
            UserId: '',
            Password: "",
            FirstName: '',
            LastName: '',
            redirectCleanersDashboard: false,
            redirectSignUp: false,
            redirectForgetPage: false,
            elementUserId : false,
            elementUserPwd : false,
            errors: {},
            Name : '',
            Role : '',
            IsActive : "",
            Id : '',
            redirectNotActive :false,
            redirectAdminConfig :false,
            redirectSuperAdminConfig :false,
            EncryptedPassword : "",
            VendorName : ''
        }
        this.handleSignIn = this.handleSignIn.bind(this);
        this.handleChangeUserName = this.handleChangeUserName.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleSignUp = this.handleSignUp.bind(this);
        this.handleBack=this.handleBack.bind(this);
        this.handleForgotPwd =this.handleForgotPwd.bind(this);
    }
    componentDidMount() {
        $(".SignInFieldLogin").keypress(function(e) {
            if(e.which == 13) {
                $(".NextField").click();
            }
        });
        // $(".PasswordField").bind('cut copy paste', function(e) {
        //     e.preventDefault();
        //   return false;
        // });
        var self = this;
        $("#PasswordSheet").hide();
            $(".NextField").click(function (e) {
                if(self.state.UserId == "") {
                    let errors = {}
                    errors["Email"] = DashboardLoginConstant.emailEmpty
                    self.setState({
                        elementUserId : true,
                        errors:errors
                    })
                }
                else {
                    self.setState({
                        loading :true
                        })
                    const AuthStr= self.state.UserId
                    GetVendors(AuthStr).then(res => {
                        let responseStoreObject = res;
                        if(responseStoreObject.data.description == "Invalid EmailID"){ /* Backend Custom Error for Invalid Email*/ 
                            let errors = {}
                            errors["Email"] = DashboardLoginConstant.InvalidUserID
                            self.setState({
                                elementUserId : true,
                                errors:errors,
                                loading :false
                            })
                        }
                        if(responseStoreObject.data.description == "User not active"){ /* Backend Custom Error for UserInactive*/
                            $(".DashboardLoginRootDiv").hide();
                            self.setState({
                                redirectNotActive :true,
                                loading :false
                            })
                        }
                        if(responseStoreObject.data.description == "Invalid Domain Name") { /* Backend Custom Error for Invalid Domain*/
                            let errors = {}
                            errors["Email"] = DashboardLoginConstant.InvalidDomain
                            self.setState({
                                elementUserId : true,
                                errors:errors,
                                loading :false
                            })
                        }
                        if (responseStoreObject.status === 200) {
                        //     var Name = responseStoreObject.data
                          sessionStorage.setItem('name', responseStoreObject.data.FirstName)
                          sessionStorage.setItem('encryptedPassword', responseStoreObject.data.Password)
                         var  Mail=  sessionStorage.setItem('email', self.state.UserId)
                            self.setState({
                                loading: false,
                                EncryptedPassword : responseStoreObject.data.Password,
                               FirstName : responseStoreObject.data.FirstName,
                              LastName : responseStoreObject.data.LastName
                            })

                            $("#UsernameField").hide();
                                $("#PasswordSheet").show();
        
                            $(".PasswordField").keypress(function(e) {
                                if(e.which == 13) {
                                    self.handleSignIn();
                                }
                            });
                        }

                    })
                    
                    // var Name = self.state.UserId.split("@")[0].split(".")[0].charAt(0).toUpperCase() + self.state.UserId.split("@")[0].split(".")[0].slice(1);
                    // self.setState({
                    //     Name :Name
                    // })  
                }
                
            });
    }
    onKeyPress = e => {
        if (this.state.UserId.length < 0) {
          this.setState({
            elementUserId: true
          });
        }
        else {
          this.setState({
            elementUserId: false
          });
        }
      };
      onKeyPressPwd = button => {
        if (this.state.Password.length < 0) {
          this.setState({
            elementUserPwd: true
          });
        }
        else {
          this.setState({
            elementUserPwd: false
          });
        }
      };
      
    handleBack =(e) => {
        this.setState({
            elementUserPwd : false,  
        })
        $(document).ready(function() {
        $("#PasswordSheet").hide();
        $("#UsernameField").show();
    })
    }
    handleChangeUserName = (e) => {
        this.setState({
            UserId: e.target.value
        })
        this.onKeyPress();
    }
    handleChangePassword = (e) => {
        this.setState({
            Password: e.target.value
        })
    }
    handleSignUp = (e) => {
        this.setState({
            redirectSignUp: true
        })
    }
    handleForgotPwd = (e) => {
        this.setState({
            redirectForgetPage: true
        })
    }

    handleSignIn = (e) => {
        if(this.state.Password == "") {
            let errors = {}
            errors["Pwd"] = DashboardLoginConstant.pwdEmpty
            this.setState({
                elementUserPwd : true,
                errors:errors
            })
        }
        else {
        this.setState({
            loading: true
        })
        let AuthData = {
            Email: this.state.UserId,
            Password: this.state.Password,
        }
        var that = this;
        bcrypt.compare(AuthData.Password,this.state.EncryptedPassword, function(err, res) { 
                if(res) {
                    Authentication(AuthData).then(res => {
            let responseJSON = res;
            if (responseJSON.status === 200) {
                sessionStorage.setItem('token', responseJSON.data.Token)
                 sessionStorage.setItem('role', responseJSON.data.Role)
                 sessionStorage.setItem('isActive', responseJSON.data.IsActive)
                sessionStorage.setItem('userId', responseJSON.data.UserId)
                sessionStorage.setItem('vendorName', responseJSON.data.VendorName)
                that.setState({
                     Role: sessionStorage.getItem('role'),
                     IsActive: sessionStorage.getItem('isActive'),
                     Id: sessionStorage.getItem('userId'),
                     VendorName : sessionStorage.getItem('vendorName')
                })
                if((responseJSON.data.Role == '1') && (responseJSON.data.IsActive == true )) {
                    that.setState({
                        redirectAdminConfig :true
                    })
                }
                if((responseJSON.data.Role == '3') && (responseJSON.data.IsActive == true )) {
                    that.setState({
                        // redirectSuperAdminConfig :true
                        redirectAdminConfig :true
                    })
                }
                if(responseJSON.data.IsActive == true) {
                    that.setState({
                        redirectCleanersDashboard :true
                    })
                }
                else {
                    that.setState({
                        redirectNotActive :true
                    })
                }
            }
        })
                }
                else {
                    let errors = {}
                    errors["Pwd"] = DashboardLoginConstant.InvalidPwd
                    that.setState({
                        elementUserPwd : true,  
                        errors:errors,
                        loading :false
                    })
                }
      });
      
       
    }
    }
    render() {
        if (this.state.redirectCleanersDashboard) {
            return (<Redirect to={'/CleanersDashboardHome'} />)
        }
        if (this.state.redirectAdminConfig) {
            return (<Redirect to={'/DashboardScheduleUploadDownload'} />)
        }
        if (this.state.redirectSuperAdminConfig) {
            return (<Redirect to={'/DashboardAdminCleaningCompanies'} />)
        }
        if (this.state.redirectSignUp) {
            return (<Redirect to={'/CleanerDashboardSignUp'} />)
        }
        if (this.state.redirectForgetPage) {
            return (<Redirect to={'/CleanersDashboardForgotPwd'} />)
        }
        return (
            <div>
                {this.state.loading ?
                    <div className="overlay"><img src={Loading} alt="Loading" className="loadingSignOut" /></div> : null}
                <div className="DashboardLoginRootDiv" id="rootDiv">
                    <div className="DashboardLoginDivHeader">
                        <DashboardLogo />
                        <h2>{DashboardLoginConstant.visit}</h2>
                        <p>{DashboardLoginConstant.cleaning}</p>
                    </div>
                    <div id="UsernameField" className="UsernameField">
                        <div className="DashboardLoginDivHeaderSignIn">
                            <h1>{DashboardLoginConstant.signIn}</h1>
                            {this.state.elementUserId ? <div><span className="errorEmail">{this.state.errors["Email"]}</span></div> : null}
                            <ReusableTextBox className="SignInFieldLogin" type="text" placeholder="Enter your email address"  onKeyPress={button => this.onKeyPress(button)} onChange={this.handleChangeUserName} />
                        </div>
                        <div className="DashboardLoginDivHeaderSignUpLink">
                            <p onClick={this.handleSignUp} >{DashboardLoginConstant.signUp}</p>
                            <ReusableButton buttonText={DashboardLoginConstant.next} className="NextField" />
                        </div>
                    </div>
                    <div id="PasswordSheet">
                        <div className="DashboardLoginDivHeaderPwd">
                        <IoMdArrowBack className="BackIcon" onClick={this.handleBack}/>
                            <h1>{DashboardLoginConstant.enterPassword}</h1>
                            <span>Hi {this.state.FirstName}</span>
                            {this.state.elementUserPwd ? <div><span className="errorEmailPwd">{this.state.errors["Pwd"]}</span></div> : null}
                            <ReusableTextBox className="PasswordField"  onChange={this.handleChangePassword} type="password" onKeyPress={button => this.onKeyPressPwd(button)} />
                        </div>
                        <div className="DashboardLoginDivHeaderForgotLogin">
                            <p onClick={this.handleForgotPwd}>{DashboardLoginConstant.forgotPassword}</p>
                            <ReusableButton onClick={this.handleSignIn} buttonText={DashboardLoginConstant.signIn} className="LoginField" />
                        </div>
                    </div>
                   
                </div>
                {this.state.redirectNotActive ? 
                    <div className="DashboardLoginNotActive" id="rootDiv">
                       <div className="DashboardLoginDivHeader">
                        <DashboardLogo />
                        <h2>{DashboardLoginConstant.visit}</h2>
                        <p>{DashboardLoginConstant.cleaning}</p>
                    </div>
                    <div className="UserNotActive">
                        <p>{DashboardLoginConstant.UserNotActive}</p>
                        <div className="Flex">
                        <p>{DashboardLoginConstant.Click}</p>
                        <p><a href="/DashboardLogin" className="Here">{DashboardLoginConstant.Here}</a></p>
                        <p>{DashboardLoginConstant.LoginAgain}</p>
                        </div>
                        <div className="Flex">
                        <p>{DashboardLoginConstant.Support}</p>
                        <p>{DashboardLoginConstant.SupportMail}</p>
                        </div>
                        
                    </div>
                    </div> : null }
            </div>
        )
    }
}

export default DashboardLogin
